import { render } from "./comment-form.vue?vue&type=template&id=2f784d18&ts=true"
import script from "./comment-form.vue?vue&type=script&lang=ts"
export * from "./comment-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__